var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevronUp = function SvgChevronUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E95FF",
    fillRule: "evenodd",
    d: "M6.293.293a1 1 0 0 1 1.414 0l6 6a1 1 0 0 1-1.414 1.414L7 2.414 1.707 7.707A1 1 0 0 1 .293 6.293z",
    clipRule: "evenodd"
  })));
};
export default SvgChevronUp;